import { Component, Inject } from '@angular/core';

import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorObject } from '@inmoment/the-kitchen';

import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';
import { AlertService } from '../../../../services/alert.service';

export interface CollectionAdvancedOptions {
  toSkip: string;
  toUpload: string;
}

@EnableClassTelemetry()
@Component({
  selector: 'app-collection-advanced-options-dialog',
  templateUrl: './collection-advanced-options-dialog.component.html',
  styleUrls: ['./collection-advanced-options-dialog.component.scss'],
  standalone: false,
})
export class CollectionAdvancedOptionsDialogComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  public readonly form: UntypedFormGroup;
  public toSkipStatus: ErrorObject | null;
  public toUploadStatus: ErrorObject | null;

  constructor(
    private dialogRef: MatDialogRef<CollectionAdvancedOptionsDialogComponent>,
    private formBuilder: UntypedFormBuilder,
    private alertService: AlertService,
    @Inject(MAT_DIALOG_DATA) private options?: CollectionAdvancedOptions
  ) {
    this.form = this.formBuilder.group({
      toSkip: [options?.toSkip, Validators.pattern('^[1-9]\\d*')],
      toUpload: [options?.toUpload, Validators.pattern('^[1-9]\\d*')],
    });
  }

  public save(): void {
    if (!this.form.controls.toSkip.value && !this.form.controls.toUpload.value) {
      this.dialogRef.close();
    } else {
      this.dialogRef.close(this.form.value);
    }
  }

  public cancel(): void {
    this.dialogRef.close(this.options);
  }
}
